/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="loader-container" v-if="isVisible">
    <div class="lds-spinner">
      <svg-loader />
    </div>
  </div>
</template>

<script>
import SvgLoader from 'theme/components/AbsoluteLoader/SvgLoader'

export default {
  name: 'Loader',
  computed: {
    isVisible () {
      return this.$store.state.ui.loader
    }
  },
  components: {
    SvgLoader
  }
}
</script>

<style lang="scss" scoped>
$color-container-bg: rgb(255, 255, 255);
$color-message-bg: #308c14;
$z-index-loader: 1051;

.loader-container {
  z-index: $z-index-loader;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba($color-container-bg, 0.7);
  position: fixed;
}

.loader-message-container {
  background-color: rgba($color-message-bg, 0.75);
  border-radius: 50px;
  letter-spacing: 0.5px;
  display: none;
}

.lds-spinner {
  color: official;
  position: relative;
  width: 120px;
  height: 120px;
  top: 50%;
  margin-top: -60px;
  left: 50%;
  margin-left: -60px;

  svg {
    width: 100%;
    height: 100%;
  }
}

</style>
